import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Stock from '@/view/record/stock/Stock'

export default {
  path: '/research/stock',
  name: 'ResearchStock',
  components: {
    default: Stock,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'research',
    area: 'record-stock',
    breadcrumb: [
      { name: 'Pesquisa', link: '/research' },
      { name: 'Estoque' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/research/StockRoute.js